import { render } from "./ClinicTemplateEdit.vue?vue&type=template&id=0e122c92&scoped=true"
import script from "./ClinicTemplateEdit.vue?vue&type=script&lang=js"
export * from "./ClinicTemplateEdit.vue?vue&type=script&lang=js"

import "./ClinicTemplateEdit.vue?vue&type=style&index=0&id=0e122c92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e122c92"]])

export default __exports__